import { render, staticRenderFns } from "./GravarContaDialog.vue?vue&type=template&id=31832020&scoped=true&"
import script from "./GravarContaDialog.vue?vue&type=script&lang=js&"
export * from "./GravarContaDialog.vue?vue&type=script&lang=js&"
import style0 from "./GravarContaDialog.vue?vue&type=style&index=0&id=31832020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31832020",
  null
  
)

component.options.__file = "GravarContaDialog.vue"
export default component.exports